package org.btmonier.games.components

import kotlinx.html.*
import kotlinx.html.dom.create
import kotlinx.browser.document
import kotlinx.browser.window
import org.btmonier.games.model.Game
import org.w3c.dom.HTMLElement

fun createAllGamesPage(games: List<Game>): HTMLElement {
    val container = document.create.div("all-games-container") {
        div("all-games-header") {
            h1("all-games-title") { +"All Games" }
            p("all-games-count") { +"${games.size} games" }
        }
        
        div("all-games-grid") {
            id = "all-games-grid"
            games.forEach { game ->
                a(href = "#game-${game.metadata.slug}", classes = "game-card md-card md-card-elevated") {
                    attributes["data-slug"] = game.metadata.slug
                    
                    div("game-card-header") {
                        h2("game-card-title") { +game.metadata.title }
                        if (game.metadata.tags.isNotEmpty()) {
                            div("game-card-tags") {
                                game.metadata.tags.take(3).forEach { tag ->
                                    span("game-card-tag") { +tag }
                                }
                            }
                        }
                    }
                    
                    if (game.metadata.status != null || game.metadata.technology != null) {
                        div("game-card-metadata") {
                            game.metadata.status?.let {
                                span("game-card-status") {
                                    span("material-icons") { +"info" }
                                    +it
                                }
                            }
                            game.metadata.technology?.let {
                                span("game-card-tech") {
                                    span("material-icons") { +"code" }
                                    +it
                                }
                            }
                        }
                    }
                    
                    span("material-icons game-card-arrow") { +"arrow_forward" }
                }
            }
        }
    }
    
    // Setup click handlers for game cards
    container.querySelectorAll(".game-card").asList().forEach { card ->
        card.addEventListener("click", { e ->
            e.preventDefault()
            val slug = card.getAttribute("data-slug") ?: return@addEventListener
            window.location.hash = "#game-$slug"
        })
    }
    
    return container
}

// Extension function to convert NodeList to List
private fun org.w3c.dom.NodeList.asList(): List<org.w3c.dom.Element> {
    val list = mutableListOf<org.w3c.dom.Element>()
    for (i in 0 until this.length) {
        this.item(i)?.let { list.add(it as org.w3c.dom.Element) }
    }
    return list
}
